import FieldEditorModal from './FieldEditorModal/FieldEditorModal';
import {
  FieldEditorSubmit,
  SourceFieldOption
} from '../helpers/articleTypeConfig.types';

type Props = {
  isOpen: boolean;
  sourceFieldOptions: SourceFieldOption[];
  mandatoryFieldNames: readonly string[];
  onClose: () => void;
  onSave: (values: FieldEditorSubmit) => void;
};

const AddFieldModal: React.FC<Props> = ({
  isOpen,
  sourceFieldOptions,
  mandatoryFieldNames,
  onClose,
  onSave
}) => (
  <FieldEditorModal
    isOpen={isOpen}
    mode="add"
    sourceFieldOptions={sourceFieldOptions}
    mandatoryFieldNames={mandatoryFieldNames}
    onClose={onClose}
    onSave={onSave}
  />
);

export default AddFieldModal;
